// Helper/getOrders.js
import myAxios from '../AxiosUrl';

export const getOrders = async (params) => {
    const {
        searchN,
        orderStatus,
        uid,
        page,
        limit,
        FilterDate,
        DateFrom,
        DateTo,
        DateSearch,
        assignedTo,
        aiStatus,
    } = params;

    const url = `get-order?searchN=${searchN}&orderStatus=${orderStatus}&uid=${uid}&page=${page}&limit=${limit}&FilterDate=${FilterDate}&DateFrom=${DateFrom}&DateTo=${DateTo}&DateSearch=${DateSearch}${assignedTo ? `&assignedTo=${assignedTo}` : ''}${aiStatus ? `&aiStatus=${aiStatus}` : ''}`;
    return myAxios.get(url);
};
